import axiosClient from './axiosClient';

export type FeasibilityReviewType = 'TECHNICAL' | 'STAFFING' | 'DELIVERY';

export interface FeasibilityReviewData {
  id?: string;
  opportunityId?: string;
  reviewType: FeasibilityReviewType;
  reviewerId?: string;
  reviewerName?: string;
  reviewerRole?: string;
  remarks: string;
  submittedAt?: string;
}

export const feasibilityApi = {
  getReviews: async (opportunityId: string): Promise<FeasibilityReviewData[]> => {
    const response = await axiosClient.get(`/opportunities/${opportunityId}/feasibility-reviews`);
    return response.data;
  },

  submitReview: async (
    opportunityId: string,
    data: { reviewType: FeasibilityReviewType; remarks: string },
  ): Promise<FeasibilityReviewData> => {
    const response = await axiosClient.post(
      `/opportunities/${opportunityId}/feasibility-reviews`,
      data,
    );
    return response.data;
  },

  reassignReview: async (
    opportunityId: string,
    reviewType: FeasibilityReviewType,
    newReviewerId: string,
  ): Promise<FeasibilityReviewData> => {
    const response = await axiosClient.put(
      `/opportunities/${opportunityId}/feasibility-reviews/${reviewType}/reassign`,
      null,
      { params: { newReviewerId } },
    );
    return response.data;
  },
};
